const s = (e, t, a) => e >= t && e <= a,
  u = (e, t) => [Math.min(e, t), Math.max(e, t)],
  p = (e, t, a) => Number.isInteger(e) ? s(e, t, a) ? e : e < t ? t : e > a ? a : e : t,
  c = (e, t, a) => {
    if (!Array.isArray(e)) return [t, a];
    if (s(e[0], t, a) && s(e[1], t, a)) return e;
    const i = e[0] < t ? t : e[0],
      n = e[1] > a ? a : e[1];
    return [i, n];
  },
  o = (e, t, a) => (e - t) / (a - t) * 100;
export { s as isBetween, u as parseMinMax, p as parseValueBetween, c as parseValuesBetween, o as percentTrack };